export interface NewPillarScore {
  pillarName: PillarName;
  value: number;
  bhiRefactorUserAssessments: UserAssessmentsScore[];
}

export enum PillarName {
  NEW_INDEX = "newIndex",
  CONNECTEDNESS = "connectedness",
  EMOTIONAL_BALANCE = "emotionalBalance",
  CLARITY = "clarity",
  EMERGING_FACTOR = "emergingFactor"
}

export enum ScoreType {
  RAW = "raw",
  PERCENTILE = "percentile"
}

export interface PillarScores {
  pillarName: string;
  value: number;
  userAssessments: UserAssessmentsScore[];
}

export interface UserAssessmentsScore {
  name: string;
  scores: Scores[];
}

export interface Scores {
  scoreName: string;
  scoreType: ScoreType;
  value: number;
}

export interface UserAssessmentsScore {
  name: string;
  scores: Scores[];
}
